import { render, staticRenderFns } from "./Admisionrapida.vue?vue&type=template&id=48f018c4"
import script from "./Admisionrapida.vue?vue&type=script&lang=js"
export * from "./Admisionrapida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports